export const EVENT_TRACKER_TIME = 'EVENT_TRACKER_TIME'
export const MANUALLY_ADDED = 'MANUALLY_ADDED'
export const SCANNED_PRODUCT = 'SCANNED_PRODUCT'
export const MULTIPLE_BATCHES = 'MULTIPLE_BATCHES'
export const PREV_ADDED_PRODUCT_TIME = 'PREV_ADDED_PRODUCT_TIME'
export const TOTAL_PRODUCTS = 'TOTAL_PRODUCTS'
export const PRODUCT_ADD_AVG_TIME = 'PRODUCT_ADD_AVG_TIME'
export const PRODUCT_ADD_TIME_ARRAY = 'PRODUCT_ADD_TIME_ARRAY'
export const PRODUCT_REMOVE_TIME_ARRAY = 'PRODUCT_REMOVE_TIME_ARRAY'
export const EDIT_ORDER_ITEM = 'EDIT_ORDER_ITEM'
export const MANUALLY_ADDED_BARCODES_ARRAY = 'MANUALLY_ADDED_BARCODES_ARRAY'
export const MANUALLY_REMOVED_ITEMS = 'MANUALLY_REMOVED_ITEMS'
export const RESET_STATE = 'RESET_STATE'
export const MANUAL_ITEMS_GTIN = 'MANUAL_ITEMS_GTIN'
export const RESET_STATE_WITHOUT_TIME = 'RESET_STATE_WITHOUT_TIME'

export const eventTrackerTime = (payload) => {
    return {type:EVENT_TRACKER_TIME,payload}
}

export const incrementScannedProduct = (payload) => {
    return {type: SCANNED_PRODUCT,payload}
}

export const incrementManuallyAddedProduct = (payload) => {
    return {type: MANUALLY_ADDED,payload}
}

export const changeMultipleBatchesValue = (payload) => {
    return {type: MULTIPLE_BATCHES,payload}
}

export const changePrevAddedTime = (payload) => {
    return {type: PREV_ADDED_PRODUCT_TIME,payload}
}

export const setTotalProducts = (payload) => {
    return {type: TOTAL_PRODUCTS,payload}
}

export const productAddAverageTime = (payload) => {
    return {type: PRODUCT_ADD_AVG_TIME,payload}
}

export const addingProductTime = (payload) => {
    return {type: PRODUCT_ADD_TIME_ARRAY,payload}
}

export const removeProductTimeArray = (payload) => {
    return {type: PRODUCT_REMOVE_TIME_ARRAY,payload}
}

export const addEditOrderItem = (payload) => {
    return {type: EDIT_ORDER_ITEM,payload}
}

export const setManuallyRemovedItems = (payload) => {
    return {type: MANUALLY_REMOVED_ITEMS,payload}
}

export const resetState = (payload) => {
    return {type: RESET_STATE,payload}
}

export const resetStateWithoutTime = (payload) => {
    return {type: RESET_STATE_WITHOUT_TIME,payload}
}

export const addManualItemsGTIN = (payload) => {
    return {type: MANUAL_ITEMS_GTIN,payload}
}